<div
    class="svg-container"
    [style.width.px]="size"
    [style.height.px]="size"
    [innerHTML]="svgHtml"
></div>
